/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




function convertToMoney(x) {
  return Number.parseFloat(x).toFixed(2);
}
Number.prototype.formatMoney = function(sign, num, comma, t) {
  var n = this,
      num = isNaN(num = Math.abs(num)) ? 2 : num,
      comma = comma == undefined ? "," : comma,
      t = t == undefined ? "." : t,
      sign = sign == undefined ? '$' : sign;
      s = n < 0 ? "-" : "",
      i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(num))),
      j = (j = i.length) > 3 ? j % 3 : 0;
  return sign + s + (j ? i.substr(0, j) + comma : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + comma) + (num ? t + Math.abs(n - i).toFixed(num).slice(2) : "")
};


function push(list, items) {
  Array.prototype.push.apply(list, items);
  list.length_ = list.length;
  list.length_ += items.length;
}


function getStyle(oElm, strCssRule){
  var strValue = "";
  if (document.defaultView && document.defaultView.getComputedStyle){
    strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
  } else if(oElm.currentStyle){
    strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1){
      return p1.toUpperCase();
    });
    strValue = oElm.currentStyle[strCssRule];
  }
  return strValue;
}


Date.prototype.addDays = function (d) {
  if (d) {
    var t = this.getTime();
    t = t + (d * 86400000);
    // this.setTime(t);
    // new Date(minDays).toLocaleDateString("en-US");
    return this.setTime(t);
  }
};

function nextweek(){
  var today = new Date();
  var nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate()+7);
  return nextweek;
}
function plusDays(d){
  if (d) {
    var today = new Date();
    var nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + d);
    return nextweek;
  }
}

const dateOptions = { day: 'numeric', month: 'numeric' };
Date.prototype.getMonthName = function(lang) {
  lang = lang && (lang in Date.locale) ? lang : 'en';
  return Date.locale[lang].month_names[this.getMonth()];
};

Date.prototype.getMonthNameShort = function(lang) {
  lang = lang && (lang in Date.locale) ? lang : 'en';
  return Date.locale[lang].month_names_short[this.getMonth()];
};

Date.locale = {
  en: {
    month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};

function getShortYear(d) {
  var shortYear = d.getFullYear(); 
  return shortYear.toString().substr(-2);
  // return twoDigitYear;
}



// let lcp;
// const po = new PerformanceObserver((eList) => {
//   const e = eList.getEntries();
//   const last = e[e.length - 1];
//   lcp = last.renderTime || last.loadTime;
//   for (const entry of e) {
//     console.log('LCP candidate:', entry.startTime, entry);
//   }
// });

// const poOpts = {
//   type: 'largest-contentful-paint',
//   buffered: true
// }
// po.observe(poOpts);

new PerformanceObserver((entryList) => {
  for (const entry of entryList.getEntries()) {
    console.log('LCP candidate:', entry.startTime, entry);
  }
}).observe({type: 'largest-contentful-paint', buffered: true})

new PerformanceObserver((entryList) => {
  for (const entry of entryList.getEntries()) {
    if (!entry.hadRecentInput) {
      console.log("LayoutShift value:", entry.value);
      if (entry.sources) {
        for (const { node, currentRect, previousRect } of entry.sources)
          console.log("LayoutShift source:", node, {
            currentRect,
            previousRect,
          });
      }
    }
  }
}).observe({ type: "layout-shift", buffered: true });



// (function() {
//   var script = document.createElement('script');
//   script.src = 'https://unpkg.com/web-vitals@3/dist/web-vitals.iife.js';
//   script.onload = function() {
//     // When loading `web-vitals` using a classic script, all the public
//     // methods can be found on the `webVitals` global namespace.
//     webVitals.onCLS(console.log(webVitals));
//     webVitals.onFID(console.log);
//     webVitals.onLCP(console.log(webVitals));
//   }
//   document.head.appendChild(script);
// }())
const quickShipValues = ['5 to 7 Days', '5 to 10 Days', '10 Days', '1 to 2 Weeks', '1 to 3 Weeks', '2 to 3 Weeks', '2 to 4 Weeks', '3 to 4 Weeks'];
const inStockValues = ['4 to 6 Weeks'];
const madeToOrder = 'Made to Order';
const quickShipText = "Quick Ship";

const shadeQuickShipValues = ['4 to 5 Weeks'];

// document.addEventListener('searchspring.domReady', function(event) {
//   console.log(event);
//   document.getElementById('skeleton-container').style.display = 'none';
// });


/**
 * --------------------------------------------------------------------
 * Custom option UI rules (centralized)
 * --------------------------------------------------------------------
 * We keep the legacy conditional blocks in-place (commented out below),
 * but prefer calling applyCustomOptionRules() from multiple lifecycle hooks.
 */
/*
function setVisible(el, shouldShow, displayStyle = 'flex') {
  if (!el) return;
  el.style.display = shouldShow ? displayStyle : 'none';
}

function setDisabled(inputEl, disabled) {
  if (!inputEl) return;
  inputEl.disabled = !!disabled;
}

function setRequired(inputEl, required) {
  if (!inputEl) return;
  inputEl.required = !!required;
}

function getSelectedColorValue(productForm) {
  if (!productForm) return null;
  const selectedColor = productForm.querySelector('.color-swatch__radio:checked');
  return selectedColor?.value || null;
}

function uncheckRadioGroupByName(name) {
  if (!name) return;
  document.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(radio => {
    radio.checked = false;
  });
}

function ensureRadioChecked({ container, id, name, value }) {
  if (!name) return null;
  let input = id ? document.getElementById(id) : null;
  if (!input) {
    input = document.createElement('input');
    input.type = 'radio';
    input.name = name;
    if (id) input.id = id;
    input.value = value;
    if (container) container.appendChild(input);
  }
  input.checked = true;
  return input;
}

function applyCustomOptionRules(ctx) {
  const { vendor, variantTitle, infiniteContainer, productForm } = ctx || {};
  if (!infiniteContainer || !vendor) return;

  const title = (variantTitle || '').toLowerCase();
  const selectedColorValue = (getSelectedColorValue(productForm) || '').toLowerCase();

  // SportsPlay: show custom color selects only when "Custom" is selected; hide for galvanized variants
  if (vendor === 'SportsPlay') {
    const sportplayColors = infiniteContainer.querySelectorAll('.sportplay-color');
    const ultraplayColors = infiniteContainer.querySelector('.ultraplay-colors');

    const isCustomVariant = title.includes('custom') || selectedColorValue === 'custom';
    const isGalvanizedVariant = title.includes('galvanized');

    sportplayColors.forEach(colorEl => {
      const select = colorEl.querySelector('select');
      const show = isCustomVariant && !isGalvanizedVariant;
      setVisible(colorEl, show);
      setRequired(select, show);
      setDisabled(select, !show);
    });

    // When galvanized, force powder_coating_color to "none"
    if (ultraplayColors) {
      ultraplayColors.classList.toggle('hidden', isGalvanizedVariant);

      if (isGalvanizedVariant) {
        uncheckRadioGroupByName('properties[powder_coating_color]');
        ensureRadioChecked({
          container: ultraplayColors,
          id: 'infinite-galvanized',
          name: 'properties[powder_coating_color]',
          value: 'none'
        });
      } else {
        document.getElementById('infinite-galvanized')?.remove();
      }
    }
  }

  // Playground Equipment / Henderson / Wisdom / World Klass Play: show PE custom color sets based on title/selection
  if (['Playground Equipment', 'Henderson', 'Wisdom', 'World Klass Play'].includes(vendor)) {
    const shouldDisplay =
      title.includes('custom') ||
      title.includes('double row') ||
      title.includes('single row') ||
      title.includes('pod climber') ||
      selectedColorValue.includes('custom');

    const isGalvanizedOrStainlessVariant = title.includes('galvanized') || title.includes('stainless');

    infiniteContainer.querySelectorAll('.pe_color').forEach(colorEl => {
      const select = colorEl.querySelector('select');
      const show = shouldDisplay && !isGalvanizedOrStainlessVariant;
      setVisible(colorEl, show);
      setDisabled(select, !show);
    });

    if (vendor === 'Playground Equipment') {
      const isGalvanized = title.includes('galvanized');
      infiniteContainer.querySelectorAll('.pe_color_zero').forEach(colorEl => {
        const select = colorEl.querySelector('select');
        setVisible(colorEl, !isGalvanized);
        setDisabled(select, isGalvanized);
      });
    }
  }

  // Ultra Play Premier: roof/shade selects only when title/option indicates they apply
  if (vendor === 'Ultra Play Premier') {
    const roofColorSelect = infiniteContainer.querySelector('.roof-colors');
    const shadeColorSelect = infiniteContainer.querySelector('.shade-colors');
    const hasRoof = title.includes('with roof');
    const hasShade = title.includes('with shade');

    if (roofColorSelect) {
      setVisible(roofColorSelect, hasRoof);
      setDisabled(roofColorSelect.querySelector('select'), !hasRoof);
    }
    if (shadeColorSelect) {
      setVisible(shadeColorSelect, hasShade);
      setDisabled(shadeColorSelect.querySelector('select'), !hasShade);
    }
  }
}
*/

const quickShipLabel = document.getElementById('quick-ship-label');
const quickShipIconArea = document.getElementById('quick-ship-image-label');
const quickShipTableIcon = document.getElementById('quick-ship-cell');

const arrival = document.getElementById('arrival');
// const leadTimeNote = document.getElementById('lead_time_note');
// const leadTimeNoteItems = document.querySelectorAll('.lead_time_note');



document.addEventListener('variant:changed', function(event, target) {
  if (event.detail.variant) {

    // const cratingFeeWidget = document.querySelector('.crating-fee-container');
    // const cratingFeeBtn = cratingFeeWidget?.querySelector('.add-btn');
    // if (cratingFeeBtn) {
    //   cratingFeeBtn?.dataset?.variant = event.detail.variant.id;
    // } 
    // cratingFeeBtn?.dataset.variant = event.detail.variant.id;
    // console.log('cratingFeeBtn.dataset.variant', cratingFeeBtn, cratingFeeBtn.dataset.variant);


    const variantId = event.detail.variant.id;
    const variantPrice = event.detail.variant.price / 100;
    const selector = document.querySelector('[id^="product-select-"]');
    const selectedVariant = selector.querySelector('[value="' + variantId + '"]');
    console.log('variant:changed', event.detail.variant, event.detail, 'variantId', variantId, 'selected', selectedVariant);
    const vendor = document.querySelector('.product-meta__vendor').textContent;
    console.log('selectedVariant', selectedVariant, selector);
    const variantTitle = event.detail.variant.title.toLowerCase();
    const productLeadTime = selector.getAttribute('data-product-lead_time').trim();
    let variantLeadTime = selectedVariant.getAttribute('data-lead_time');
    let variantMaxLeadTime = parseInt(selectedVariant.getAttribute('data-max_lead_time'));
    // let variantMinLeadTime = parseInt(selectedVariant.getAttribute('data-min_lead_time'));
    let leadTime = productLeadTime;

    // JF - REMOVE AFTER 3/1/2026
    // const leadTimeNumbers = variantLeadTime.match(/\d+\s*to\s*\d+/);
    // if (event.detail.vendor === 'Playground Equipment' && leadTimeNumbers && variantMaxLeadTime > 6) {
    //   variantLeadTime = `${leadTimeNumbers[0]} Weeks`;
    // }

    // JF - REMOVE AFTER 5/6/2026
    if (event.detail.vendor === 'NetPlay USA' ) {
      variantLeadTime = '10 to 12 weeks';
    }

    // console.log('event.detail.variant', event.detail.variant);

    
    const leadTimeEl = document.getElementById('product-lead-time');
    const leadTimeInput = document.getElementById('lead_time');

    const crating_fee = document.getElementById('crating_fee');
    if (crating_fee) { crating_fee.textContent = selectedVariant.getAttribute('data-crating-fee'); }

    const fr_fabric_fee = document.getElementById('fr_fabric_fee_variant_id');
    if (fr_fabric_fee) { fr_fabric_fee.textContent = selectedVariant.getAttribute('data-fr-fabric'); }

    // console.log('event.detail.vendor', event.detail.vendor);

    if (!variantLeadTime || variantLeadTime === "" ) {
      leadTimeEl.innerHTML = productLeadTime;
      leadTime = productLeadTime;
    } else {
      leadTimeEl.innerHTML = variantLeadTime;
      leadTime = variantLeadTime;
      leadTimeInput.value = variantLeadTime;
    }

    
    if (leadTime && arrival) {
      let [variantMinLeadTime, variantMaxLeadTime] = leadTime.match(/\d+/g).map(Number);

      if (variantMinLeadTime && variantMaxLeadTime) {
        const now = new Date();
        const minDate = new Date(now.setDate(now.getDate() + variantMinLeadTime * 7));
        const maxDate = new Date(now.setDate(now.getDate() + (variantMaxLeadTime - variantMinLeadTime) * 7));
        
        arrival.querySelector('#arrival_min').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(minDate);
        arrival.querySelector('#arrival_max').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(maxDate);
      }
    }
    

    // Change the weight when variant is changed
    const weightEl = document.querySelector('#prod-weight');
    const variantWeight = selectedVariant.getAttribute('data-weight');
    if (weightEl && variantWeight) {
      weightEl.innerHTML = variantWeight;
    }

    
    const shadeSizeEl = document.querySelector('#shade_size');
    if (shadeSizeEl) {
      shadeSizeEl.textContent = event.detail.variant.title;
    }
    
    
    // Icons on gallery
    // console.log('variantMaxLeadTime', variantMaxLeadTime);

    const isShadeStructures = event.detail.vendor === 'Shade Structures';
    const isQuickShip = isShadeStructures ? variantMaxLeadTime <= 5 : variantMaxLeadTime <= 4;
    const isMadeToOrder = isShadeStructures ? variantMaxLeadTime >= 12 : variantMaxLeadTime >= 14;

    // if(leadTimeNote) {
    //   leadTimeNote.classList.toggle('hidden', isQuickShip);
    // }

    // if(leadTimeNoteItems) {
    //   leadTimeNoteItems.forEach(item => {
    //     item.classList.toggle('hidden', isQuickShip);
    //   });
    // }


    if (quickShipLabel) {
      quickShipLabel.classList.toggle('hidden', !isQuickShip && !isMadeToOrder);
      quickShipLabel.textContent = isQuickShip ? quickShipText : madeToOrder;
      quickShipTableIcon?.classList.toggle('hidden', !isQuickShip);
      quickShipIconArea?.classList.toggle('hidden', !isQuickShip && !isMadeToOrder);

      if (quickShipIconArea) {
        quickShipIconArea.querySelector('#quick-ship-label-text').textContent = isQuickShip ? quickShipText : madeToOrder;
        quickShipIconArea.querySelector('.icon').classList.toggle('hidden', isMadeToOrder);
      }

      
      // if (event.detail.vendor != 'Shade Structures') {
      //   if (variantMaxLeadTime <= 4) {
      //     quickShipLabel.classList.remove('hidden');
      //     quickShipLabel.textContent = quickShipText;
      //     quickShipTableIcon?.classList.remove('hidden');
      //     if (quickShipIconArea) {
      //       // console.log('quickShipIconArea1', quickShipIconArea);
      //       quickShipIconArea.classList.remove('hidden');
      //       quickShipIconArea.querySelector('#quick-ship-label-text').textContent = quickShipText;
      //       quickShipIconArea.querySelector('.icon').classList.remove('hidden');
      //     }
      //   } else if (variantMaxLeadTime >= 5 && variantMaxLeadTime <= 13) {
      //     // console.log('quickShipLabel1', quickShipLabel);
      //     quickShipLabel.classList.add('hidden');
      //     quickShipIconArea?.classList.add('hidden');
      //     quickShipTableIcon?.classList.add('hidden');
      //   } else if (variantMaxLeadTime >= 14) {
      //     // console.log('quickShipLabel2', quickShipLabel);
      //     quickShipLabel.classList.remove('hidden');
      //     quickShipLabel.textContent = madeToOrder;
      //     if (quickShipIconArea) {
      //       // console.log('quickShipIconArea2', quickShipIconArea);
      //       quickShipIconArea.classList.remove('hidden');
      //       quickShipIconArea.querySelector('#quick-ship-label-text').textContent = madeToOrder;
      //       quickShipIconArea.querySelector('.icon').classList.add('hidden');
      //     }
      //     quickShipTableIcon?.classList.add('hidden');
      //   } else {
      //     // console.log('quickShipLabel3', quickShipLabel);
      //     quickShipLabel.classList.add('hidden');
      //     quickShipIconArea?.classList.add('hidden');
      //     quickShipTableIcon?.classList.add('hidden');
      //   }
      // } else {
      //   if (variantMaxLeadTime <= 5) {
      //     quickShipLabel.classList.remove('hidden');
      //     quickShipLabel.textContent = quickShipText;
      //     quickShipTableIcon?.classList.remove('hidden');
      //     if (quickShipIconArea) {
      //       // console.log('quickShipIconArea1', quickShipIconArea);
      //       quickShipIconArea.classList.remove('hidden');
      //       quickShipIconArea.querySelector('#quick-ship-label-text').textContent = quickShipText;
      //       quickShipIconArea.querySelector('.icon').classList.remove('hidden');
      //     }
      //   } else if (variantMaxLeadTime >= 12) {
      //     // console.log('quickShipLabel2', quickShipLabel);
      //     quickShipLabel.classList.remove('hidden');
      //     quickShipLabel.textContent = madeToOrder;
      //     if (quickShipIconArea) {
      //       // console.log('quickShipIconArea2', quickShipIconArea);
      //       quickShipIconArea.classList.remove('hidden');
      //       quickShipIconArea.querySelector('#quick-ship-label-text').textContent = madeToOrder;
      //       quickShipIconArea.querySelector('.icon').classList.add('hidden');
      //       // quickShipIconArea.querySelector('.icon').setAttribute('src', '//cdn.shopify.com/s/files/1/0100/6072/6369/files/calendar.svg?v=1739227512');
      //     }
      //     quickShipTableIcon?.classList.add('hidden');
      //   } else {
      //     // console.log('quickShipLabel3', quickShipLabel);
      //     quickShipLabel.classList.add('hidden');
      //     quickShipIconArea?.classList.add('hidden');
      //     quickShipTableIcon?.classList.add('hidden');
      //   }
      // }
    }




    const infiniteContainer = document.getElementById('infiniteoptions-container');

    updateAddonPrices(infiniteContainer, variantPrice);
    checkSelectsForCustomOptions();
    
    // checkNetPlayRopeSelects();
    


    // HIDE AND SHOW CUSTOM COLOR OPTIONS INFINITE OPTIONS
    if (event.detail.vendor === 'SportsPlay') {
      const sportplayColors = infiniteContainer.querySelectorAll('.sportplay-color');
      const ultraplayColors = infiniteContainer.querySelector('.ultraplay-colors');
      const isCustomVariant = variantTitle.includes("custom");
      const isGalvanizedVariant = variantTitle.includes("galvanized");
    
      // Toggle visibility and requirement of SportsPlay color options
      sportplayColors.forEach(color_el => {
        color_el.style.display = isCustomVariant ? "flex" : "none";
        color_el.getElementsByTagName('select')[0].required = isCustomVariant;

        color_el.style.display = !isGalvanizedVariant ? "flex" : "none";
      });

      // if(sportplayColors.length != 0) {
      //   sportplayColors.forEach(color_el => { 
      //     console.log('color_el', color_el, isGalvanizedVariant);
      //     color_el.classList.toggle('hidden', isGalvanizedVariant);
      //   });
      // }
    
      // Handle UltraPlay color options
      if (ultraplayColors) {
        ultraplayColors.classList.toggle('hidden', isGalvanizedVariant);
        const galvInput = document.getElementById('infinite-galvanized');
        if (isGalvanizedVariant) {
          // Uncheck all other powder_coating_color radio buttons first
          // const allInputs = document.querySelectorAll('input[name="properties[powder_coating_color]"], input[name="properties[color]"]');
          
          // allInputs.forEach(radio => {
          //   radio.checked = false;
          // });

          // document.querySelectorAll('select[name="properties[powder_coating_color]"], select[name="properties[color]"]').forEach(select => {
          //   select.selectedIndex = 0;
          // });

          ['properties[powder_coating_color]', 'properties[color]'].forEach(name => {
            document.querySelectorAll(`[name="${name}"]`).forEach(el => {
              if (el.type === 'radio' || el.type === 'checkbox') el.checked = false;
              else if (el.tagName === 'SELECT') el.selectedIndex = 0;
            });
          });
          
          if (!galvInput) {
            let galv = document.createElement('input');
            galv.type = 'radio';
            galv.name = 'properties[powder_coating_color]';
            galv.id = 'infinite-galvanized';
            galv.value = 'none';
            galv.checked = true;
            ultraplayColors.appendChild(galv);
          } else {
            galvInput.checked = true;
          }
        } else {
          galvInput?.remove();
        }
      }
    }

    // console.log('event.detail.vendor', event.detail.vendor, vendor, ['Playground Equipment', 'Henderson', 'Wisdom', 'World Klass Play'].includes(event.detail.vendor));

    // SHOW HIDE THE CUSTOM COLOR OPTIONS FOR CUSTOM PLAYGROUNDS AND HIDE FOR PLAYFUL/NATURAL
    if (['Playground Equipment', 'Henderson', 'Wisdom', 'World Klass Play'].includes(event.detail.vendor)) {
      
      const shouldDisplay = variantTitle.includes("custom") || variantTitle.includes("double row") || variantTitle.includes("single row") || variantTitle.includes("pod climber");
      const isGalvanizedOrStainlessVariant = variantTitle.includes("galvanized") || variantTitle.includes("stainless");
      console.log('isGalvanizedOrStainlessVariant', isGalvanizedOrStainlessVariant);
      if (!isGalvanizedOrStainlessVariant) {
        infiniteContainer.querySelectorAll('.pe_color').forEach(color_el => {
          const select = color_el.querySelector('select');
          color_el.style.display = shouldDisplay ? "flex" : "none";
          if (select) {
            select.disabled = !shouldDisplay;
          }
        });
      }
    
      if (event.detail.vendor === 'Playground Equipment') {
        const isGalvanized = variantTitle.includes("galvanized");
        infiniteContainer.querySelectorAll('.pe_color_zero').forEach(color_el => {
          const select = color_el.querySelector('select');
          console.log('isGalvanized', isGalvanized, color_el);
          color_el.style.display = isGalvanized ? "none" : "flex";
          if (select) {
            select.disabled = isGalvanized;
          }
        });
      }
    }

    // CUSTOM ULTRAPLAY COLOR OPTIONS
    if (event.detail.vendor == 'Ultra Play Premier') {
      const roofColorSelect = infiniteContainer.querySelector('.roof-colors');
      const shadeColorSelect = infiniteContainer.querySelector('.shade-colors');
      const hasRoof = variantTitle.includes("with roof");
      const hasShade = variantTitle.includes("with shade");
    
      roofColorSelect.style.display = hasRoof ? "flex" : "none";
      roofColorSelect.querySelector('select').disabled = !hasRoof;
      shadeColorSelect.style.display = hasShade ? "flex" : "none";
      shadeColorSelect.querySelector('select').disabled = !hasShade;
    }


  }

});





window.addEventListener('quote:item:added', (event) => {
  // console.log('quotes-added', event);
  let quoteItem = document.querySelector('.header__quote-count-new');
  quoteItem.classList.add('newItemAdded');
});


document.addEventListener('quickview:open', (event) => {
  console.log('quickview:open', event);
});


document.addEventListener('contextmenu', function (e) {
  if (e.target.closest('.product-gallery__image') || e.target.closest('.product-gallery__thumbnail') || e.target.closest('.snize-item-image') ) {
  // if (e.target.closest('.product-gallery__image') || e.target.closest('.product-gallery__thumbnail') || e.target.closest('.snize-item-image') || e.target.closest('.pswp__ui')) {
    e.preventDefault();
  }
});

// Optional: also block dragging the image to save it
document.addEventListener('dragstart', function (e) {
  if (e.target.closest('.product-gallery__image')) {
    e.preventDefault();
  }
});



document.addEventListener("DOMContentLoaded", () => {

  // const nofication_clsoe_btn = document.querySelector('.notification__close');
  // if(nofication_clsoe_btn) {
  //   nofication_clsoe_btn.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     leadTimeNote.classList.add('hidden');
  //   });
  // }

  // HIDE CONTENT FOR IP 76.107.199.185
  // fetch('https://ipinfo.io?callback')
  // .then(res => res.json())
  // .then(json => {
  //   if (json.ip == "76.107.199.185") {
  //     document.body.innerHTML = `<div class="content_blocked" style="padding: 10rem; text-align: center; margin: auto">This content is not available in your country</div>`;
  //   }
  // });
  

  const first_tab = document.querySelector('.product-horiz-tabs-wrapper .tab-list li');

  if (first_tab) {
    first_tab.setAttribute('aria-expanded', true);
    const targetTab = document.querySelector('.product-horiz-tabs-wrapper .tabs-panel .tab-panel');
    targetTab.classList.add('expanded')
    targetTab.setAttribute('aria-expanded', true);
  }
  

  if (document.querySelector('.horiz-tabs-wrapper')) {
    new HorizontalTabsManager();
  }

  const pdfDownloadButton = document.querySelector('.download-pdf-link');
  if (pdfDownloadButton) {
    pdfDownloadButton.addEventListener('click', (event) => {
      event.preventDefault();
      openPdfInModal(this.href, this.getAttribute('data-quote-number'));
    });

    
  }



  



  



  
  // QUOTE CENTER
  

  const updateIframe = document.getElementById('airtable-update');
  const approvalIframe = document.getElementById('airtable-approval');
  const rejectionIframe = document.getElementById('airtable-rejection');
  const noQuoteFound = document.getElementById('no-quote-found');

  const viewQuoteiFrame = document.getElementById('quote_pdf_iframe');


  if (updateIframe || approvalIframe || rejectionIframe || viewQuoteiFrame) {

    const params = new URLSearchParams(window.location.search);
    const quote_pdf_url_link = params.get('quote_pdf');
    const quote_pdf_url_link_encoded = encodeURIComponent(quote_pdf_url_link);
    const quote_pdf_link_decoded = decodeURIComponent(quote_pdf_url_link);
    const quote_number = params.get('quote_number');
    const quote_number_encoded = encodeURIComponent(quote_number);
    const page_title = document.querySelector('.page__title');

    const quote_total = params.get('quote_total');

    console.log('quote_pdf_link_decoded', quote_pdf_link_decoded, quote_pdf_url_link);
    
    // const quote = params.get('quote_number');
    // const quote_pdf = params.get('quote_pdf');

    const view_quote_url = `https://willygoat.com/pages/view-quote?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;
    // console.log('view_quote_url', view_quote_url);
    // console.log('quote_number', quote_number, quote_number_encoded);

    // progressInterval = setInterval(updateProgress, interval);

    
    const setIframeSrc = (iframe, quote_number_enc, path) => {
      iframe.src = `https://airtable.com/embed/appWFiIyEXilk7wtJ/${path}/form?prefill_Quote%20Number=${quote_number_enc}`;
    };

    

    const setTextContent = (id, container) => {
      const element = document.getElementById(id);
      if (element) element.textContent = container;
    };

    const setPageTitle = (quote_number) => {
      const titleContent = page_title.textContent;
      if (page_title && quote_number) page_title.textContent = `${titleContent} - ${quote_number}`;
    };

    

    const approveButton = document.getElementById('approve-quote-btn');
    if (approveButton) approveButton.href = `https://willygoat.com/pages/quote-approval?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    const declineButton = document.getElementById('decline-quote-btn');
    if (declineButton) declineButton.href = `https://willygoat.com/pages/quote-rejection?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    const updateButton = document.getElementById('update-quote-btn');
    if (updateButton) updateButton.href = `https://willygoat.com/pages/quote-updates?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    const viewQuoteButton = document.getElementById('view-quote-btn');
    if (viewQuoteButton) viewQuoteButton.href = `https://willygoat.com/pages/view-quote?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    const updateLink = document.getElementById('modify-link');
    if (updateLink) updateLink.href = `https://willygoat.com/pages/quote-updates?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    const approveLink = document.getElementById('approve-link');
    if (approveLink) approveLink.href = `https://willygoat.com/pages/quote-approval?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;



    const approveButton2 = document.getElementById('approve-quote-btn2');
    if (approveButton2) approveButton2.href = `https://willygoat.com/pages/quote-approval?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    const declineButton2 = document.getElementById('decline-quote-btn2');
    if (declineButton2) declineButton2.href = `https://willygoat.com/pages/quote-rejection?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    const updateButton2 = document.getElementById('update-quote-btn2');
    if (updateButton2) updateButton2.href = `https://willygoat.com/pages/quote-updates?quote_number=${quote_number_encoded}&quote_pdf=${quote_pdf_url_link_encoded}${quote_total ? `&quote_total=${quote_total}` : ''}`;

    // console.log('declineButton', declineButton, approveButton, updateButton, viewQuoteButton);


    const hideIframe = (iframe) => {
      iframe.src = '';
      iframe.style.display = 'none';
      document.querySelector('#quote-page-content .page__content-inner').textContent = '';
      pageTitle.textContent = 'No Quote Found';
      
      noQuoteFound.textContent = 'We couldn\'t find a quote with that quote number. Please send us a message our contact our customer service representatives if you need further help.';
      noQuoteFound.style.minHeight = '340px';
      document.querySelector('.blog-sidebar__item:last-of-type').style.display = 'none';
      const goatImg = new Image();
      goatImg.src = 'https://cdn.shopify.com/s/files/1/0100/6072/6369/files/goat-fail-new.gif?v=1597690418';
      goatImg.style.width = '320px';
      goatImg.style.height = 'auto';
      noQuoteFound.appendChild(goatImg);
    };

    if (viewQuoteiFrame) {
      let iframe = '<object class="contain" data="' + quote_pdf_link_decoded + '#toolbar=1&navpanes=0&statusbar=0" width="100%" height="' + window.innerHeight + '" style="height: 92vh;"><p>Your web browser doesn\'t have a PDF plugin. Instead you can <a href="' + quote_pdf_link_decoded + '">click here to download.</a></p></object>';
      // let embed_pdf = '<embed class="contain" src="' + quote_pdf_link_decoded + '#toolbar=1&navpanes=1&statusbar" width="100%" height="' + window.innerHeight + '" style="height: 90vh;"><p>Your web browser doesn\'t have a PDF plugin. Instead you can <a href="' + quote_pdf_link_decoded + '">click here to download.</a></p>';
      viewQuoteiFrame.innerHTML = iframe;
      // if (page_title && quote_number) {
      //   let currentTitle = 'View Quote';
      //   page_title.textContent = `${currentTitle} - ${quote_number}`;
      // }
      const pdfDownloadButton = document.getElementById('pdf-download-button');
      if (pdfDownloadButton && quote_pdf_url_link) {
        console.log('pdfDownloadButton', quote_pdf_url_link);
        pdfDownloadButton.href = quote_pdf_url_link;
      } else {
        pdfDownloadButton?.remove();
      }
    }

    if (quote_number_encoded && (updateIframe || approvalIframe || rejectionIframe)) {
      if (updateIframe) setIframeSrc(updateIframe, quote_number_encoded, 'pagfNbfHAPJCrMP3s');
      else if (approvalIframe) setIframeSrc(approvalIframe, quote_number_encoded, 'pagcfr8s4KmFB7TuY');
      else if (rejectionIframe) setIframeSrc(rejectionIframe, quote_number_encoded, 'pagerLKSyXD3t3cjI');
      // noQuoteFound?.style.display = 'none';

      const pdfDownloadButton1 = document.getElementById('pdf-download-button2');
      if (pdfDownloadButton1 && quote_pdf_link_decoded) {
        // pdfDownloadButton1.href = view_quote_url;
        pdfDownloadButton1.addEventListener('click', (event) => {
          event.preventDefault();
          openPdfInModal(quote_pdf_link_decoded, quote_number_encoded);
        });
      }

      const quotePdfLink = document.querySelector('.quote_pdf_link');
      if (quotePdfLink && view_quote_url) {
        quotePdfLink.href = view_quote_url;
        
        // Open PDF in modal when clicked
        // if (quote_pdf_link_decoded) {
        //   quotePdfLink.addEventListener('click', (event) => {
        //     event.preventDefault();
        //     openPdfInModal(quote_pdf_link_decoded);
        //   });
        // }


      } else {
        quotePdfLink?.remove();
      }

      
    } else {
      [updateIframe, approvalIframe, rejectionIframe].forEach(iframe => iframe && hideIframe(iframe));
    }

    

    setTextContent('quote-number', quote_number);
    setPageTitle(quote_number);
    // setTextContent('quote-email', email);
    // setTextContent('quote-total', total);

    const chatButton = document.getElementById('quote-update-button');
    if (chatButton && quote_number) {
      chatButton.addEventListener('click', () => {
        // if (email) window.GorgiasChat.captureUserEmail(email);
        if (updateIframe) {
          window.GorgiasChat.setCurrentInput(`Hello, I need to make changes to my quote ${quote_number}`);
        } else if (approvalIframe) {
          window.GorgiasChat.setCurrentInput(`Hello, I want to move forward with my quote ${quote_number}`);
        } else if (rejectionIframe) {
          window.GorgiasChat.setCurrentInput(`Hello, I have a question about my quote ${quote_number}`);
        }
        window.GorgiasChat.open();
      });
    }

    const achChatButton = document.getElementById('quote_chat');
    const achTextBtn = document.getElementById('ach-button');
    // console.log('achChatButton', achChatButton);
    if (achChatButton && quote_number) {
      achChatButton.addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for quote ${quote_number}`);
        window.GorgiasChat.open();
      });
    }

    if (achTextBtn && quote_number) {
      achTextBtn.addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for quote ${quote_number}`);
        window.GorgiasChat.open();
      });
    }

  
  }





  const quotePortal = document.getElementById('quote_portal');

  if (quotePortal) {
    const hash = window.location.hash || '';
    const q = hash.indexOf('?');
    const quote_name = q >= 0 ? new URLSearchParams(hash.slice(q)).get('quote_name') : null;
    const quoteOrOrder = quote_name && /^\d/.test(quote_name) ? 'order' : 'quote';

    console.log('quote_name', quote_name, quotePortal, quoteOrOrder);
    const chatButton = document.getElementById('quote-update-button');
    const achChatButton = document.getElementById('quote_chat');
    const achTextBtn = document.getElementById('ach-button');

    if (chatButton && quote_name) {
      chatButton.addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I have questions about my ${quoteOrOrder} ${quote_name}`);
        window.GorgiasChat.open();
      });
    } else if (chatButton) {
      chatButton.addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I have questions about my Order or Quote`);
        window.GorgiasChat.open();
      });
    }

    
    // console.log('achChatButton', achChatButton);
    if ((achChatButton && quote_name) || (achTextBtn && quote_name)) {
      (achChatButton || achTextBtn).addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for ${quoteOrOrder} ${quote_name}`);
        window.GorgiasChat.open();
      });
    } else if (achChatButton || achTextBtn) {
      (achChatButton || achTextBtn).addEventListener('click', () => {
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for my Quote`);
        window.GorgiasChat.open();
      });
    }

    // if (achTextBtn && quote_name) {
    //   achTextBtn.addEventListener('click', () => {
    //     window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for ${quoteOrOrder} ${quote_name}`);
    //     window.GorgiasChat.open();
    //   });
    // } else if (achTextBtn) {
    //   chatButton.addEventListener('click', () => {
    //     window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for my Quote`);
    //     window.GorgiasChat.open();
    //   });
    // }


    // const params = new URLSearchParams(window.location.search);
    // const hashParams = q >= 0 ? new URLSearchParams(hash.slice(q)) : new URLSearchParams();
    // const open_pdf_from_hash = hashParams.get('open_pdf');
    // const searchParams = new URLSearchParams(window.location.search);

    // // const open_pdf_param = params.get('open_pdf');
    // const open_pdf_param = searchParams.get('open_pdf') || hashParams.get('open_pdf');
    // console.log('open_pdf_param', open_pdf_param, params, hash);

    // if (open_pdf_param === '1' || open_pdf_param === 'true' || open_pdf_param === 'yes') {
    //   openPdfInModal(pdfDownloadButton.href, pdfDownloadButton.getAttribute('data-quote-number'));
    // }
  }



  function getAbsoluteHeight(el) {
    el = (typeof el === 'string') ? document.querySelector(el) : el;
    var styles = window.getComputedStyle(el);
    var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
    return Math.ceil(el.offsetHeight + margin);
  }


  // window.Shopify.customerPrivacy.setTrackingConsent({
  //   "marketing": true,
  //   "analytics": true,
  //   "preferences": true,
  //   // "checkoutRootDomain": "checkout.willygoat.shop",
  //   // "storefrontRootDomain": "willygoat.com",
  //   // "storefrontAccessToken": "e21a63df79533cc99106fd28e31ecdd0"
  //   }, () => console.log('consent was submitted')
  // )
  

  var paymentIcons = document.querySelectorAll(".footer svg.payment-list__item");
  paymentIcons.forEach(icon => {
    var titleElement = icon.querySelector("title");
    if (titleElement) {
      icon.removeAttribute('aria-labelledby');
      icon.setAttribute('aria-label', titleElement.textContent);
      var spanElement = document.createElement("title");
      spanElement.innerHTML = titleElement.textContent;
      icon.replaceChild(spanElement, titleElement);
    }
  });






  let originalLeadTimeElement = document.getElementById('product-lead-time');
  if (window.currentVariant && document.querySelector('[id^="product-select-"]')) {
    const variantId = currentVariant.id;
    const selector = document.querySelector('[id^="product-select-"]');
    const selectedVariant = selector.querySelector(`[value="${variantId}"]`);
    const productLeadTime = selector.getAttribute('data-product-lead_time').trim();
    let variantLeadTime = selectedVariant.getAttribute('data-lead_time') || productLeadTime;
    const variantMaxLeadTime = parseInt(selectedVariant.getAttribute('data-max_lead_time'));
    const leadTimeNumbers = variantLeadTime.match(/\d+\s*to\s*\d+/);
    
    
    document.getElementById('product-lead-time').innerHTML = variantLeadTime;
    // console.log('leadTimeNumbers', leadTimeNumbers);

    updateQuickShipIcons(variantMaxLeadTime);
    updateArrivalDates(variantLeadTime);

    // JF - REMOVE AFTER 3/1/2026
    // if (window.currentVariant && window.currentProduct.vendor === 'Playground Equipment' && leadTimeNumbers && variantMaxLeadTime >= 6) {
    //   originalLeadTimeElement.innerHTML = `${leadTimeNumbers[0]} Weeks`;
    // }


    // JF - REMOVE AFTER 5/6/2026
    if (window.currentVariant && window.currentProduct.vendor === 'NetPlay USA') {
      originalLeadTimeElement.innerHTML = '10 to 12 weeks';
    }


  } else if (window.currentProduct) {
    
    let originalLeadTime = originalLeadTimeElement.textContent;
    const leadTimeInput = document.getElementById('lead_time');
    const leadTimeNumbers = originalLeadTime.match(/\d+\s*to\s*\d+/);
    // console.log('leadTimeNumbers', leadTimeNumbers);


    if (leadTimeInput) {
      const leadTime = leadTimeInput.value;
      const matches = leadTime.match(/\d+/g);

      let maxLeadTime;
  
      if (matches) {
        if (leadTime.includes('to')) {
          // For ranges like "10 to 12 Weeks", get the second number
          maxLeadTime = parseInt(matches[1]);
        } else {
          // For single numbers like "10 Weeks", get the first number
          maxLeadTime = parseInt(matches[0]);
        }
      }
      maxLeadTime = leadTime.includes('Days') ? 1 : maxLeadTime;
      console.log('maxLeadTime', leadTime, maxLeadTime);


      // let maxLeadTime = matches ? parseInt(matches[1]) : null;
      // maxLeadTime = leadTime.includes('Days') ? 1 : maxLeadTime;
      // console.log('maxLeadTime', leadTime, maxLeadTime);
      if (maxLeadTime) {
        updateQuickShipIcons(maxLeadTime);
      }

      // console.log('maxLeadTime', maxLeadTime);

      // JF - REMOVE AFTER 3/1/2026
      if (window.currentProduct && window.currentProduct.vendor === 'Playground Equipment' && leadTimeNumbers && variantMaxLeadTime >= 6) {
        originalLeadTimeElement.innerHTML = `${leadTimeNumbers[0]} Weeks`;
      }

    }
  }

  

  function updateQuickShipIcons(maxLeadTime) {
    if (!quickShipLabel) return;

    const isQuickShip = maxLeadTime <= 4;
    const isMadeToOrder = maxLeadTime >= 14;
    const isShadeQuickShip = window.currentProduct.vendor === 'Shade Structures' && maxLeadTime <= 5;

    const showQuickShip = isQuickShip || isShadeQuickShip;
    const showMadeToOrder = isMadeToOrder;

    quickShipLabel.classList.toggle('hidden', !showQuickShip && !showMadeToOrder);
    quickShipLabel.textContent = showQuickShip ? quickShipText : madeToOrder;

    quickShipTableIcon?.classList.toggle('hidden', !showQuickShip);
    quickShipIconArea?.classList.toggle('hidden', !showQuickShip && !showMadeToOrder);

    // if(leadTimeNote) {
    //   leadTimeNote.classList.toggle('hidden', isQuickShip);
    // }

    // if(leadTimeNoteItems) {
    //   leadTimeNoteItems.forEach(item => {
    //     item.classList.toggle('hidden', isQuickShip);
    //   });
    // }

    const quickShipLabelText = quickShipIconArea?.querySelector('#quick-ship-label-text');
    const quickShipIcon = quickShipIconArea?.querySelector('.icon');

    if (quickShipLabelText) {
      quickShipLabelText.textContent = showQuickShip ? quickShipText : madeToOrder;
    }
    if (quickShipIcon) {
      quickShipIcon.classList.toggle('hidden', showMadeToOrder);
    }
  }

  function updateArrivalDates(leadTime) {
    const arrival = document.getElementById('arrival');
    if (leadTime && arrival) {
      const [variantMinLeadTime, variantMaxLeadTime] = leadTime.match(/\d+/g).map(Number);
      if (variantMinLeadTime && variantMaxLeadTime) {
        const now = new Date();
        const minDate = new Date(now.setDate(now.getDate() + variantMinLeadTime * 7));
        const maxDate = new Date(now.setDate(now.getDate() + (variantMaxLeadTime - variantMinLeadTime) * 7));
        arrival.querySelector('#arrival_min').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(minDate);
        arrival.querySelector('#arrival_max').textContent = new Intl.DateTimeFormat('en-us', dateOptions).format(maxDate);
      }
    }
  }
  



});



window.addEventListener('load', () => {

  captureAndStoreGclid();


  const params = new URLSearchParams(window.location.search);
  if (params.get('invoice_number')) {
    setTimeout(() => {
      const invoiceNumber = params.get('invoice_number');
      console.log('invoiceNumber', invoiceNumber);
      if (invoiceNumber ) {
        // window.GorgiasChat.init();
        window.GorgiasChat.setCurrentInput(`Hello, I would like to request ACH information for order ${invoiceNumber}`);
        window.GorgiasChat.open();
      }
    }, 1000);
  }




  const shopifyAccessibilityIssue = document.querySelector('shop-cart-sync iframe');
  if (shopifyAccessibilityIssue) {
    shopifyAccessibilityIssue.title = 'Shopify Cart Sync';
  }
  // console.log('shopifyAccessibilityIssue', shopifyAccessibilityIssue);

  // Custom Click For Images
  if (window.location.pathname.includes('/collections/')) {
    let swatchImages = document.querySelectorAll('.snize-color-swatch-box .snize-color-swatch');

    swatchImages.forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        const productItem = swatch.closest('.snize-product');
        const collectionItem = productItem.querySelector('.snize-view-link');
        collectionItem.classList.add('hover');

        const isCustomColor = swatch.getAttribute('data-value') === 'Custom';
        if (productItem.classList.contains('snize-product-tag-__labelquick-ship')) {
          const quickShipLabel = productItem.querySelector('.snize-product-label.top-right');
          quickShipLabel.classList.toggle('hidden', isCustomColor);
        }
      });
    });
  }

  let convertButtons = document.querySelectorAll('.convert_to_cart_button');
  if (convertButtons) {
    convertButtons.forEach( convertButton => {
      convertButton.addEventListener('click', convertQuoteToCart);
    });
  }

  // document.querySelectorAll('.blog-testimonials-blocks_slider .flickity-slider .blog-testimonials__item').style.height = '100%';
  document.querySelectorAll('.blog-testimonials-blocks_slider .flickity-slider .blog-testimonials__item').forEach(item => {
    item.style.height = '100%';
  });

  if (window.currentProduct && quickShipLabel) {
    if (currentProduct.tags.includes('__label:Quick Ship') && currentProduct.title == "GaGa2Go Portable GaGa Ball Pit") {
      quickShipLabel.classList.remove('hidden');
    }
  }


  


  // Hide filters if there is only one option
  const productTypeFilter = document.getElementById('snize_filters_block_product_type');
  const productTypeFilterItems = productTypeFilter?.querySelectorAll('.snize-product-filters-list li');

  if (productTypeFilter && productTypeFilterItems.length == 1) {
    productTypeFilter.closest('.snize-product-filters-block').style.display = 'none';
  }

  const banner_img = document.querySelector('.snize-banner a img');
  banner_img && (banner_img.alt = 'WillyGoat Installation Services');

  if (banner_img && window.innerWidth < 768) {
    banner_img.closest('.snize-banner').style.display = 'none';
  }

  // const filters = document.querySelectorAll('.snize-product-filters-list');
  // filters.forEach(filter => {
  //   let filterItems = filter.querySelectorAll('li');
  //   if (filterItems.length == 1) {
  //     filter.closest('.snize-product-filters-block').style.display = 'none';
  //   }
  // });

  


  /*
  // CLONE BANNER IMAGE FOR SIDEBAR 
  const banner = document.querySelector('.snize-banner a').cloneNode(true);
  const sidebar = document.querySelector('.snize-filters-sidebar');
  var bannerContainer = document.createElement('div');
  bannerContainer.classList.add('sidebar-snize-banner');
  bannerContainer.appendChild(banner);
  sidebar.appendChild(bannerContainer);
  */


  


});



// JOEL - JF
var HorizontalTabsManager = class {
  constructor() {
    this.tabs = document.querySelector('.horiz-tabs-wrapper');
    
    this.tabLinks = this.tabs.querySelectorAll('.horiz-tab');
    this.tabPanes = this.tabs.querySelectorAll('.tab-panel');
    // this.domDelegate = new main_default(document.body);
    console.log('this.tabs', this.tabLinks);
    this._attachListeners();
  }
  _attachListeners() {
    // this.domDelegate.on("click", '[data-action="toggle-tabs"]:not([disabled])', this._handleTabClick.bind(this));
    // document.addEventListener("tabs:toggle", this._handleTabClick.bind(this));

    this.tabLinks.forEach(tab => {
      tab.addEventListener('click', (event) => this._handleTabClick(tab) );
    });
  }

  _handleTabClick(target) {
    this.tabLinks.forEach((tab) => {
      tab.classList.remove('expanded');
      tab.setAttribute('aria-expanded', false);
    });
    this.tabPanes.forEach((pane) => {
      pane.classList.remove('expanded');
      pane.setAttribute('aria-expanded', false);
    });

    const tabId = target.getAttribute('aria-controls');
    const targetTab = document.getElementById(tabId);
    target.setAttribute('aria-expanded', true);
    targetTab.classList.add('expanded')
    targetTab.setAttribute('aria-expanded', true);
  }
  

}




document.addEventListener('theme:loading:end', function(event) {
  // sortSelect(prodTypeSelect);

  maxHeightGallery();

  

  // let menu = document.getElementById('mobile-menu');
  // let mainListElements = menu.querySelectorAll('.mobile-menu__panel');
  // if (mainListElements) {
  //   mainListElements.forEach(menuItem => {
  //     let collapsibleItem = menuItem.querySelector('.mobile-menu__nav-collapsible');
  //     if (collapsibleItem) {
  //         let id = collapsibleItem.getAttribute('id');
  //         // console.log('collapsibleItem', collapsibleItem);
  //         if (collapsibleItem && collapsibleItem.previousElementSibling.getAttribute('aria-expanded') != 'true') {
  //           document.dispatchEvent(new CustomEvent('collapsible:toggle', {
  //             detail: {
  //               id: id
  //             }
  //           }));
  //          }
  //     }
  //   });
  // }



  

  // Open all links in the tabs into a modal rather than opening a new window or tab
  let productLinks = document.querySelectorAll('.product-block-list__item--content a[target="_blank"]:not(.download-pdf), .product-block-list__item--info .product-block-list__item:not(.product-block-list__item--share) a[target="_blank"], .mini-cart__property-list a.manual_url[target="_blank"]');
  // console.log('[-- productLinks --]', productLinks);
  // if (window.matchMedia('screen and (min-width: 640px)').matches) {
    openDocsInModal(productLinks);
  // }
  


  
  // Sort Product Types in Native Search (Not Shown when using Boost Search)
  let prodTypeSelect = document.getElementById('search-product-type');
  if (prodTypeSelect) {
    const optionNodes = Array.from(prodTypeSelect.children);
    const comparator = new Intl.Collator(optionNodes.value).compare;
    prodTypeSelect.innerHTML = "";
    optionNodes.sort((a, b) => comparator(a.textContent, b.textContent));
    optionNodes.forEach((option) => prodTypeSelect.appendChild(option));
  }


  // let shippingProvinceSelect = document.getElementById('shipping-estimator-country');
  // if (shippingProvinceSelect) {
  //   let provincesJsonData = shippingProvinceSelect.getAttribute('data-provinces');
  //   if (provincesJsonData) {
  //     let provincesJSON = JSON.parse(provincesJsonData);
  //     const comparator = new Intl.Collator(provincesJSON).compare;
  //     shippingProvinceSelect.innerHTML = "";
  //     provincesJSON.filter((j, b) => !j.includes('Virgin Islands') && !j.includes('Puerto Rico') && !j.includes('Palau') && !j.includes('Mariana Islands') && !j.includes('Hawaii') && !j.includes('Marshall Islands') && !j.includes('Alaska') && !j.includes('Guam') && !j.includes('Armed Forces') && !j.includes('Marshall') && !j.includes('Micronesia') && !j.includes('Armed Forces Americas') && !j.includes('American Samoa') && !j.includes('Armed Forces Europe') && !j.includes('Armed Forces Pacific') && !j.includes('Northern Mariana Islands') )
  //     let json2 = provincesJSON.filter(j => (
  //       !j.includes('Virgin Islands') && !j.includes('Puerto Rico') && !j.includes('Palau') && !j.includes('Mariana Islands') && !j.includes('Hawaii') && !j.includes('Marshall Islands') && !j.includes('Alaska') && !j.includes('Guam') && !j.includes('Armed Forces') && !j.includes('Marshall') && !j.includes('Micronesia') && !j.includes('Armed Forces Americas') && !j.includes('American Samoa') && !j.includes('Armed Forces Europe') && !j.includes('Armed Forces Pacific') && !j.includes('Northern Mariana Islands') 
  //     ))
  //     console.log(json2);
  //     // shippingProvinceSelect.setAttribute('data-provinces', json2);
  //   }
  // }
  




  // Track Manual Clicks
  const manualTab = document.getElementById('unique-tab-resources');
  const productJsonElement = document.querySelector('[data-product-json]');
  if (productJsonElement && manualTab) {
    const manualLinks = manualTab.querySelectorAll('.manual_url');
    let jsonData = JSON.parse(productJsonElement.innerHTML);
    let productData = jsonData['product'];
    // console.log('productData', productData);

    const trackManualClick = (productData) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'product_manual_open',
        product: productData.title,
        url: 'https://willygoat.com/products/' + productData.handle,
        brand: productData.vendor
      });
      manualLink.removeEventListener('click', trackManualClick);
    }
  
    manualLinks.forEach(manualLink => {
      manualLink.addEventListener('click', trackManualClick);
    });
  }

  
});




function captureAndStoreGclid() {
  const urlParams = new URLSearchParams(window.location.search);
  // const gclidParam = urlParams.get('gclid') || getGclidFromElevar();
  const gclidParam = urlParams.get('gclid');
  // let storedGclid = localStorage.getItem('gclid_value');

  // utm_campaign
  const utm_campaign = urlParams.get('utm_campaign');
  // const magazineVisitor = urlParams.get('Church_10_24');

  if (gclidParam) {
    const gclidValue = JSON.stringify(gclidParam);
    localStorage.setItem('gclid_value', gclidParam);
    // localStorage.setItem('gclid', gclidParam);
    localStorage.setItem('google_ads_click_id', gclidParam);
  }

  if (utm_campaign == 'Church_10_24') {
    localStorage.setItem('wg_church_10_24_visitor', 'true');
  }
}

function getGclidFromElevar() {
  const elevarData = localStorage.getItem('___ELEVAR_GTM_SUITE--params');
  if (elevarData) {
    const parsedElevarData = JSON.parse(elevarData);
    return parsedElevarData.google_ads_click_id?.replace('gclid:', '');
  }
  return null;
}



/*
function getParam(p) {
  let match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
  
function getExpiryRecord(value) {
  const expiryPeriod = 90 * 24 * 60 * 60 * 1000;
  let expiryDate = new Date().getTime() + expiryPeriod;
  return {
    value: value,
    expiryDate: expiryDate
  };
}

function addGclid() {
  let gclidParam = getParam('gclid');
  // let gclidRecord = null;

  if (gclidParam) {
    // gclidRecord = getExpiryRecord(gclidParam);
    localStorage.setItem('gclid', JSON.stringify(gclidParam));
    localStorage.setItem('gclid_value', JSON.stringify(gclidParam));
  }

  let elevarData = localStorage.getItem('___ELEVAR_GTM_SUITE--params');
  if (elevarData) {
    let parsedElevarData = JSON.parse(elevarData);
    let gclid = parsedElevarData.gclid ? parsedElevarData.gclid : parsedElevarData.google_ads_click_id ? parsedElevarData.google_ads_click_id?.replace('gclid:', '') : JSON.stringify(gclidParam);
    
    localStorage.setItem('google_ads_click_id', JSON.stringify(gclid));
  }
}
*/





const equalHeightTitles = (elems) => {
  const heights = elems.map(el => el.querySelector('.product__title-heading').offsetHeight);
  const maxHeight = Math.max(...heights);
  elems.forEach(el => {
    el.querySelector('.product__title-heading').style.height = `${maxHeight}px`;
  });
};

const maxHeightGallery = function() {
  if (window.matchMedia('screen and (min-width: 1024px)').matches && document.querySelectorAll('.product-gallery__carousel').length ) {
    let productCarousel = document.querySelectorAll('.product-gallery__carousel')[0];
    let galleryThumbs = document.querySelectorAll('.product-gallery__thumbnail-list')[0];
    if (galleryThumbs) {
      let origHeight = parseInt(getStyle(galleryThumbs, "max-height"));
      if ( productCarousel.clientHeight >= origHeight ) {
        galleryThumbs.style['maxHeight'] = "".concat((productCarousel.clientHeight - 8), "px");
      }
    }
  }
}



var sortSelect = function(selElem) {
  var tmpAry = new Array();
  for (var i = 0; i < selElem.options.length; i++) {
    tmpAry[i] = new Array();
    tmpAry[i][0] = selElem.options[i].text;
    tmpAry[i][1] = selElem.options[i].value;
  }
  tmpAry.sort();
  while (selElem.options.length > 0) {
    selElem.options[0] = null;
  }
  for (var i=0;i<tmpAry.length;i++) {
    var op = new Option(tmpAry[i][0], tmpAry[i][1]);
    selElem.options[i] = op;
  }
  return;
}












// document.addEventListener('theme:loading:end', function(event) {
window.Shoppad = window.Shoppad || {},
window.Shoppad.apps = window.Shoppad.apps || {},
window.Shoppad.apps.infiniteoptions = window.Shoppad.apps.infiniteoptions || {},
window.Shoppad.apps.infiniteoptions.ready = function() {

  const infiniteContainer = document.getElementById('infiniteoptions-container');
  const vendor = document.querySelector('.product-meta__vendor').textContent;

  const productForm = document.querySelector('.product-form');

  // UPlay Premier Roof Options Customizations
  const mainSelector = productForm.querySelector('.product-form__single-selector');
  if (mainSelector && vendor === 'Ultra Play Premier') {
    const selectedRoofOption = mainSelector.options[mainSelector.selectedIndex].value;

    const roofColors = infiniteContainer.querySelector('.roof-colors:not([disabled="disabled"])');
    const shadeColors = infiniteContainer.querySelector('.shade-colors:not([disabled="disabled"])');

    roofColors.style.display = selectedRoofOption.includes("With Roof") ? "flex" : "none";
    shadeColors.style.display = selectedRoofOption.includes("With Shade") ? "flex" : "none";
  }
  


  // let mounting_option = infiniteContainer.querySelector('#mounting_option-0-0');
  const mounting_option = infiniteContainer.querySelector('[for^="mounting_option-"], [id^="mounting_option-"], [for^="mounting_options-"], [id="mounting_option-1-0"]');
  const install_tab = document.querySelector('[class^="tab-installation-tab"], .tab-installation-tab, .tab-installation-tab-pe, .tab-installation-shades');
  
  if ( mounting_option && install_tab ) {
    mounting_option.setAttribute('data-tooltip', 'Please see installation tab below for more information.');
  }

  
  const colorSwatches = infiniteContainer.querySelectorAll('.ultraplay-colors, .rope-color, .uplay-colors');
  colorSwatches.forEach(swatch => {
    const label = swatch.querySelector('.spb-label-tooltip label');
    const labelText = label.textContent + ':&nbsp;';
    const inputs = swatch.querySelectorAll('input[type=radio], input[type=checkbox]');
    const skuArea = document.querySelector('.product-meta__sku-number');
    const skuValue = skuArea.textContent;

    const updateLabel = (input) => {
      label.innerHTML = `${labelText}<span class='product-form__selected-value'>${input.value}</span>`;
      if (skuArea ) {
        skuArea.textContent = `${skuValue} - ${input.value}`.trim();
      }
    };

    inputs.forEach(input => {
      if (input.checked) updateLabel(input);
      input.addEventListener('change', () => updateLabel(input));
    });
  });

  // Show the select boxes value in the accoompanying label when selected
  const infinSelects = infiniteContainer.querySelectorAll('.spb-select');
  // console.log('infinSelects', infinSelects);
  infinSelects.forEach(select => {
    let label = select.closest('.infin-option').querySelector('.spb-label-tooltip label');
    const labelText = label.textContent + ':&nbsp;';

    select.addEventListener('change', (event) => {
      // console.log('event', event.target);
      label.innerHTML = labelText + "<span class='product-form__selected-value'>" + event.target.value + "</span>";
    });
  });

  // Hide and show all the custom color options when they select custom as a playground option.
  // const productForm = document.querySelector('.product-form');
  const selectedColor = productForm.querySelector('.color-swatch__radio:checked');

  if ( selectedColor && infiniteContainer.querySelectorAll('.sportplay-color') && vendor == 'SportsPlay' ) {
    const sportplayColors = infiniteContainer.querySelectorAll('.sportplay-color');
    const displayStyle = selectedColor.value.toLowerCase() !== "custom" ? "none" : "flex";
    const required = selectedColor.value.toLowerCase() === "custom";

    sportplayColors.forEach(color_el => {
      color_el.style.display = displayStyle;
      color_el.getElementsByTagName('select')[0].required = required;
    });
  }

  
  // Hide and show all the custom color options when they select custom as a playground option.
  // console.log('vendor', vendor, selectedColor);
  if ( selectedColor && infiniteContainer.querySelectorAll('.pe_color') && (vendor == 'Playground Equipment' || vendor == 'Henderson' || vendor == 'Wisdom' || vendor == 'World Klass Play' ) ) {
    infiniteContainer.querySelectorAll('.pe_color:not([disabled="disabled"])').forEach(custom_option_set => {
      custom_option_set.style.display = selectedColor.value.toLowerCase().includes("custom") ? "flex" : "none";
    });
    // infiniteContainer.querySelectorAll('.pe_option:not([disabled="disabled"])').forEach(pe_option_set => {
    //   pe_option_set.style.display = selectedColor.value.toLowerCase().includes("custom") ? "flex" : "none";
    // });
  }

  

  if (vendor == 'Playground Equipment' && window.location.pathname == "/products/sit-n-spin" ) {
    const mainSelector = productForm.querySelector('.product-form__single-selector');
    const hideColors = ['yellow', 'red', 'tan', 'pacific blue'];
    if (mainSelector && hideColors.includes(mainSelector.value.toLowerCase())) {
      infiniteContainer.querySelectorAll('.pe_color').forEach(el => {
        el.style.display = 'none';
      });
    }
  }

  
  // infiniteContainer.querySelectorAll('.pe_color_zero').forEach(color_el => {
  //   const mainSelector = productForm.querySelector('.product-form__single-selector');
  //   let isGalvanized = mainSelector.value.toLowerCase().includes("galvanized");
  //   console.log('isGalvanized', isGalvanized, color_el);
  //   color_el.style.display = isGalvanized ? "none" : "flex";
  //   if (color_el) {
  //     color_el.querySelector('select').disabled = isGalvanized;
  //   }
  // });




  


  updateAddonPrices(infiniteContainer);
  checkSelectsForCustomOptions();
  
  // checkNetPlayRopeSelects();

  // Check if the california resident radio button is checked and update the add to cart button
  if (document.querySelector('[name="properties[california_resident]"]')) {
    const californiaRadios = document.getElementsByName('properties[california_resident]');
    const cartBtn = document.querySelector('.product-form__add-button');
    const paymentContainer = cartBtn.closest('.product-form__payment-container');
    const shopifyPaymentBtn = document.querySelector('.shopify-payment-button');
    const galleryImageLinks = document.querySelectorAll('.product-gallery__thumbnail');

    californiaRadios.forEach(radio => {
      radio.addEventListener('change', (event) => {
        const isCaliforniaResident = event.target.value === 'Yes';
        cartBtn.classList.toggle('visually-hidden', isCaliforniaResident);
        paymentContainer.classList.toggle('no-quote', isCaliforniaResident);
        shopifyPaymentBtn.classList.toggle('visually-hidden', isCaliforniaResident);
        if (vendor == 'Shade Structures') {
          console.log('galleryImageLinks', galleryImageLinks, isCaliforniaResident, galleryImageLinks.length);
          galleryImageLinks[isCaliforniaResident ? galleryImageLinks.length - 1 : 3].click();
        }
      });
    });
  }


};







// Infinite Options - Adds the price to the extra product options 
const updateAddonPrices = (infiniteContainer, variantPrice = window.currentVariant.price / 100) => {
  const productForm = document.querySelector('.product-form');
  const variantPriceEl = productForm.querySelector('.price-list .price');

  if (variantPrice) {
    const infiniteInputs = infiniteContainer.querySelectorAll('input:not([type=hidden]), select');
    const updatePrice = () => {
      const updatedPrice = calculateTotalPrice(infiniteContainer, variantPrice);
      variantPriceEl.innerHTML = updatedPrice.formatMoney('$', 2, ',', '.');
    };

    infiniteInputs.forEach(inputEl => {
      updatePrice(); // Initial price update
      inputEl.addEventListener('change', updatePrice);
    });
  }
};

const calculateTotalPrice = (container, basePrice) => {
  const inputs = container.querySelectorAll("input:not([type=hidden]), select");

  const additionalPrice = Array.from(inputs).reduce((total, inputEl) => {
    let priceToAdd = 0;
    const nextSibling = inputEl.nextSibling;

    if ((inputEl.type === 'radio' || inputEl.type === 'checkbox') && inputEl.checked && nextSibling && nextSibling.nodeType === Node.ELEMENT_NODE && nextSibling.hasAttribute('data-price')) {
      priceToAdd = parseFloat(inputEl.nextSibling.getAttribute('data-price'));
    } else if (inputEl.type === 'select-one' && inputEl.selectedIndex >= 0) {
      const selectedOption = inputEl.options[inputEl.selectedIndex];
      if (selectedOption.hasAttribute('data-price')) {
        priceToAdd = parseFloat(selectedOption.getAttribute('data-price'));
      }
    }
    return total + priceToAdd;
  }, 0);

  return basePrice + additionalPrice;
};






const checkSelectsForCustomOptions = () => {
  const selects = document.querySelectorAll('.product-form__single-selector');
  if (!selects.length) return;

  const toggleVisibility = (element, condition, input = null) => {
    if (!element) return;
    element.classList.toggle('hidden', !condition);
    if (input) {
      input.checked = condition;
      if (!condition) input.remove();
    }
  };

  const checkCustomPEColors = function () {
    const selectedColorSelect = document.querySelector('#option-color');
    if (!selectedColorSelect) return;
    const peColor = document.querySelector('.pe_color');
    const isCustomColor = selectedColorSelect.value.toLowerCase().includes('custom');
    toggleVisibility(pePostColor, !isCustomColor);
    peColor.querySelector('select').disabled = isCustomColor;
  }


  // ZERO STILL
  const checkZeroStill = function () {
    const selectedModelSelect = document.querySelector('#option-model');
    if (!selectedModelSelect) return;
    const pePostColor = document.querySelector('.pe_color_zero');
    const isGalvanized = selectedModelSelect.value.toLowerCase().includes('galvanized');
    toggleVisibility(pePostColor, !isGalvanized);
    pePostColor.querySelector('select').disabled = isGalvanized;
  }

  const checkPZSSeries = function () {
    const selectedPostSelect = document.querySelector('#option-post');
    if (!selectedPostSelect) return;
    const pePostColor = document.querySelector('.pe_color_zero');
    const isGalvanized = selectedPostSelect.value.toLowerCase().includes('galvanized');
    toggleVisibility(pePostColor, !isGalvanized);
    pePostColor.querySelector('select').disabled = isGalvanized;
  }

  

  const checkNetPlayRopeSelects = function () {
    const ropeGaugeSelect = document.querySelector('#option-rope_gauge');
    if (!ropeGaugeSelect) return;
  
    const ropeColorOptionsSelect16mm = document.querySelector('.rope-color-options');
    const ropeColorOptionsSelect18mm = document.querySelector('.rope-color-18mm');
    
    if (ropeColorOptionsSelect16mm && ropeColorOptionsSelect18mm) {
      const is18mm = ropeGaugeSelect.value === '18 MM';
      // ropeColorOptionsSelect16mm.classList.toggle('hidden', is18mm);
      toggleVisibility(ropeColorOptionsSelect16mm, !is18mm);
      ropeColorOptionsSelect16mm.querySelector('select').disabled = is18mm;
      // ropeColorOptionsSelect18mm.classList.toggle('hidden', !is18mm);
      toggleVisibility(ropeColorOptionsSelect18mm, is18mm);
      ropeColorOptionsSelect18mm.querySelector('select').disabled = !is18mm;
    }
  }

  const handleUltraPlayColors = () => {
    const ultraPlayColorSelect = document.querySelector('.ultraplay-colors');
    if (!ultraPlayColorSelect) return;

    selects.forEach(select => {
      const isGalvanized = select.options[select.selectedIndex]?.value === 'Galvanized';
      console.log('isGalvanized', isGalvanized);
      
      if (isGalvanized) {
        // Uncheck all other powder_coating_color radio buttons first
        document.querySelectorAll('input[name="properties[powder_coating_color]"]').forEach(radio => {
          radio.checked = false;
        });

        document.querySelectorAll('select[name="properties[powder_coating_color]"], select[name="properties[color]"]').forEach(select => {
          select.selectedIndex = 0;
        });

        
        let galvInput = document.getElementById('infinite-galvanized');
        if (!galvInput) {
          const galv = document.createElement('input');
          galv.type = 'radio';
          galv.name = 'properties[powder_coating_color]';
          galv.id = 'infinite-galvanized';
          galv.value = 'none';
          galv.checked = true;
          ultraPlayColorSelect.appendChild(galv);
        } else {
          galvInput.checked = true;
        }
        toggleVisibility(ultraPlayColorSelect, false, null);
      } else {
        const galvInput = document.getElementById('infinite-galvanized');
        if (galvInput) {
          galvInput.remove();
        }
        toggleVisibility(ultraPlayColorSelect, true, null);
      }
    });
  };

  const handleBracketColors = () => {
    const bracketColorSelect = document.querySelector('.bracket-color select');
    if (!bracketColorSelect) return;

    const opt = document.createElement('option');
    opt.value = 'none';
    opt.id = 'infinite-brackets';
    opt.innerHTML = 'None';

    selects.forEach(select => {
      const isNoBrackets = select.classList.contains('brackets') && select.options[select.selectedIndex]?.value === 'No';
      toggleVisibility(bracketColorSelect.closest(".bracket-color"), !isNoBrackets, opt);
    });
  };

  handleUltraPlayColors();
  handleBracketColors();
  checkNetPlayRopeSelects();
  // checkCustomPEColors();
  checkZeroStill();
  checkPZSSeries();


}


















const convertQuoteToCart = async (event) => {
  event.preventDefault();
  try {
    const quoteItemsRaw = localStorage.getItem('quoteItems');
    if (!quoteItemsRaw) {
      console.error('No quote items found in localStorage.');
      return;
    }

    const quoteItems = JSON.parse(quoteItemsRaw);
    // const items = quoteItems.map(({ variantId, quantity, options }) => ({
    //   id: variantId,
    //   quantity,
    //   properties: options ? options.reduce((acc, { key, value }) => ({ ...acc, [key.replace('_', '')]: value }), {}) : {}
    // }));
    const items = quoteItems
      .filter(({ tags, quoteOnly }) => !tags || !tags.includes('Hide Price') || !quoteOnly)
      .map(({ variantId, quantity, options }) => ({
        id: variantId,
        quantity,
        properties: options ? options.reduce((acc, { key, value }) => ({ ...acc, [key.replace('_', '')]: value }), {}) : {}
    }));

    const formData = { items };
    const response = await fetch(`${window.routes.cartAddUrl}.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) throw new Error('Network response was not ok.');

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    document.querySelector('.header__cart-toggle')?.click();
  } catch (error) {
    console.error('Error converting quote to cart:', error);
  }
};





function openPdfInModal(pdfUrl, pdfTitle) {
  let modal = document.getElementById('modal-pdf-links');
  if (!modal || !pdfUrl) {
    console.log('Modal or PDF URL missing', { modal: !!modal, pdfUrl: !!pdfUrl });
    return;
  }

  let modalTitle = modal.querySelector('.modal__title');
  if (pdfTitle && modalTitle) {
    const titleContent = decodeURIComponent(pdfTitle);
    modalTitle.textContent = titleContent;
  }
  let modalContent = modal.querySelector('.modal__content');
  let closeBtn = modal.querySelector('.modal__close');
  let iframe = '<object class="contain" data="' + pdfUrl + '" width="100%" height="' + window.innerHeight + '" style="height: 70vh;"><p>Your web browser doesn\'t have a PDF plugin. Instead you can <a href="' + pdfUrl + '">click here to download.</a></p></object>';
  modalContent.innerHTML = iframe;

  let onOpen = function onOpen(event) {
    if (event.propertyName === 'visibility') {
      modal.removeEventListener('transitionend', onOpen);
      closeBtn.addEventListener('click', closeModal);
      document.body.addEventListener('click', checkClickOutside);
      document.body.addEventListener('keyup', escapePressed);
    }
  };

  function closeModal() {
    let onClose = function onClose(event) {
      if (event.propertyName === 'visibility') {
        modal.removeEventListener('transitionend', onClose);
        modal.dispatchEvent(new CustomEvent('modal:closed'));
        closeBtn.removeEventListener('click', closeModal);
        document.body.removeEventListener('keyup', escapePressed);
        document.body.removeEventListener('click', checkClickOutside);
      }
    };

    modal.addEventListener('transitionend', onClose);
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('is-locked');
  }

  function checkClickOutside(event) {
    if (modal && (!modal.contains(event.target) || modal === event.target)) {
      closeModal();
    }
  }

  function escapePressed(event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  }

  modal.addEventListener('transitionend', onOpen);
  modal.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('is-locked');
}

function openDocsInModal(linksArray) {
  linksArray.forEach(decorateLinks);
  function decorateLinks(link, index) {
    let href_value = link.getAttribute("href");
    let modal = document.getElementById('modal-pdf-links');

    if (modal && window.matchMedia('screen and (min-width: 640px)').matches && /\.(gif|jpg|jpeg|tiff|png|pdf|pdf\\?55|jpg\\?55|png\\?55|pdf\\?.*|jpg\?.*)$/i.test(href_value)) {
      let modalContent = modal.querySelector('.modal__content');
      let closeBtn = modal.querySelector('.modal__close');

      link.onclick = function(event) {
        let iframe = '<object class="contain" data="' + href_value + '" width="100%" height="' + window.innerHeight + '" style="height: 70vh;"><p>Your web browser doesn\'t have a PDF plugin. Instead you can <a href="' + href_value + '">click here to download.</a></p></object>';
        modalContent.innerHTML = iframe;

        let onOpen = function onOpen(event) {
          if (event.propertyName === 'visibility') {
            modal.removeEventListener('transitionend', onOpen);
            closeBtn.addEventListener('click', closeModal);
            document.body.addEventListener('click', checkClickOutside);
            document.body.addEventListener('keyup', escapePressed);
          }
        };

        modal.addEventListener('transitionend', onOpen);
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('is-locked');

        return false;
      }

      function closeModal() {
        let onClose = function onClose(event) {
          if (event.propertyName === 'visibility') {
            modal.removeEventListener('transitionend', onClose);
            modal.dispatchEvent(new CustomEvent('modal:closed'));
            closeBtn.removeEventListener('click', onClose);
            document.body.removeEventListener('keyup', escapePressed);
            document.body.removeEventListener('click', checkClickOutside);
          }
        };

        modal.addEventListener('transitionend', onClose);
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('is-locked');

        return false;
      }

      function checkClickOutside(event) {
        if (modal && (!modal.contains(event.target) || modal === event.target)) {
          closeModal();
        }
      }

      function escapePressed(event) {
        if (event.key === 'Escape') {
          closeModal();
        }
      }
    }
  }
}


function strip(html){
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent||tmp.innerText;
}


async function htmlToPDFFlyer(){
  // var jsPDF = window.jspdf.jsPDF;
  var doc = new jsPDF();
  // var doc = new jsPDF('p', 'in', [8.5, 11]);
  // var footer = '<a href="https:willygoat.com">willygoat.com</a> | <a href="mailto:fun@willygoat.com">fun@willygoat.com</a> | 888-920-4628';
  var footer = 'willygoat.com | fun@willygoat.com | 888-920-4628';
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();
  today = mm + '/' + dd + '/' + yyyy;
  
  var product_template = "https://cdn.shopify.com/s/files/1/0100/6072/6369/files/Sell_Sheet_Template7.png?v=1757090669";
  var product_image = document.querySelector(".product-gallery__image");
  let main_image = product_image.src;

  var product_title = document.querySelector(".product-meta__title");
  var product_vendor = document.querySelector(".product-meta__vendor");
  var product_description = document.querySelector(".description-above > p");
  var product_specification = document.querySelector("#unique-tab-product_specs");
  
  // var product_weight = document.querySelector("#prod-weight");

  var features_list_items = document.querySelectorAll('#unique-tab-features .tab-list:not(#play-events-list)');

  var spec_details = document.querySelector('#unique-tab-product_specs');
  var spec_list_items;
  if (spec_details) {
    spec_list_items = spec_details.querySelectorAll('.tab-list:not(.secondary-list)');
  }

  var play_events = document.querySelector('#play-events-list');
  var play_events_rows = document.querySelectorAll('#play-events-list li');
  var spec_table, spec_table_rows, spec_labels, spec_values;
  if (product_specification) {
    spec_table = product_specification.querySelector('.spec-table');
    spec_table_rows = spec_table.querySelectorAll('tr');
    // spec_labels = spec_table.querySelectorAll('.spec-label').textContent;
    // spec_values = spec_table.querySelectorAll('.spec-value').textContent;
  }

  

  var materials = document.querySelector('#materials-list');
  var materials_rows = document.querySelectorAll('#materials-list li');
  
  var sale_price = document.querySelector(".product-form__info-item .price--highlight");
  var regular_price = document.querySelector(".product-form__info-item .price--compare");
  var regular_price_solo = document.querySelector('.product-form__info-content .price ');

  // console.log('spec_table_rows', spec_table_rows);
  
  var html_code = '<style>'
                    + '*, *:before, *:after { box-sizing: border-box!important; line-height: 0.5; font-family: "Open Sans",-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; }'
                    + 'html, body { color: #677279; font-family: "Open Sans",-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"; box-sizing: border-box!important; }'
                    + '.heading, h1, h2, h3, h4, h5, h6 { color: #317853; font-weight: bold; margin: 0 0 2px 0; text-transform:uppercase; }'
                    + 'h3{font-size:16px;margin:0;}'
                    + 'h4{font-size:15px;margin:0;text-transform:uppercase;}'
                    + 'h5{font-size:14px;margin:0;text-transform:uppercase;}'
                    + 'ul,li{list-style:none;margin:2px 0;}'
                    + 'table{color:#677279;border-collapse:collapse;border-spacing:0;margin:0;}'
                    + 'table tr{display:table-row;font-size:10px;}'
                    + 'table tr td{display:table-cell;border:1px solid #d5d7d9; padding: 1px 2px; margin:0!important; }'
                    + 'table tr td > * {margin:0;line-height:0.2;}'
                    + 'p {color:#677279;font-size:10px;line-height:0.2;}'
                    + 'span {color:#677279;font-size:10px;line-height:0.2;}'
                    + 'table span {color:#677279;font-size:10px;line-height:0.2;padding:0;margin:0;}'
                    + '.row-content {font-size:10px;color:#677279;line-height:0.2;padding:0;margin:0;}'
                    + '.list-item {color:#677279;}'
                + '</style>'
  // Open container div
  // html_code += ';
  html_code += '</br></br></br></br></br></br><div class="date" style="float:right;color:#677279;font-size:14px;">' + today + '</div>';
  html_code += '<div style="font-family: "Open Sans",Helvetica,sans-serif;">';
  
  html_code += ''
    +     '<h4 style="text-align:left;color:#317853; margin-top: 15px;">'+product_title.innerHTML+'</h4>';
  html_code += '</br>';

  if (product_image) {
    html_code += '<div><img align="right" style="float:right;min-height:60px;" src=' + main_image + ' width="80" ></div>';
  }
  // doc.setFontSize(12);
  if (product_vendor) {
    html_code += '<div style="line-height:16px;font-size:14px;color:#317853;"><span style="color:#317853;">Brand: </span> <span style="color:#677279;font-weight:bold;">' + product_vendor.textContent + '</span></div>';
  }
  doc.setFontSize(14);
  if (regular_price) {
    var regular_price_val = regular_price.innerHTML.replace('<span class="visually-hidden">Regular Price</span>', '').trim();
    html_code += '<div style="line-height:16px;font-size:14px;"><span style="color:#677279;line-height:16px;">Regular Price: </span> <span style="color:#677279;font-weight:bold;line-height:16px;text-decoration:line-through;">' + regular_price_val + '</span></div>';
  }

  if (sale_price) {
    var sale_price_val = sale_price.innerHTML.replace('<span class="visually-hidden">Sale Price</span>', '').trim();
    html_code += '<div style="line-height:16px;font-size:14px;"><span style="color:red;line-height:16px;">Sale Price: </span> <span style="color:#000000;font-weight:bold;line-height:16px;">' + sale_price_val + '</span></div>';
  } else if (regular_price_solo) {
    var regular_price_solo_val = regular_price_solo.innerHTML.replace('<span class="visually-hidden">Sale Price</span>', '').trim();
    html_code += '<div style="line-height:16px;font-size:14px;"><span style="color:red;line-height:16px;">Price: </span> <span style="color:#000000;font-weight:bold;line-height:16px;">' + regular_price_solo_val + '</span></div>';
  }

  if (play_events_rows.length) {
    html_code += '</br>';
    html_code += '<h5 class="heading" style="font-size:12px;font-weight:bold;margin:2px 0 2px 0;line-height:0;">Play Events: </h5>';
    html_code += '<div style="margin:2px 0;">';
    play_events_rows.forEach( row => {
      html_code += '<span class="row-content" style="font-size:10px!important; line-height:0px;" >' + row.textContent + ' &nbsp;</span>';
    });
    html_code += '</div>';
  }


  if (features_list_items) {
    html_code += '</br>';
    features_list_items.forEach( feature_list => {
      // console.log('feature_list', feature_list);
      // doc.setTextColor(49, 120, 83);
      if (feature_list.previousElementSibling) {
        html_code += '<h5 class="heading"  style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">' + strip(feature_list.previousElementSibling.innerText) + ':</h5>';
      } else if (feature_list.classList.contains('expandable-content')) {
        html_code += '<h5 class="heading"  style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">' + strip(feature_list.closest('.list-expandable-wrapper').previousElementSibling.textContent) + ':</h5>';
      } else {
        html_code += '<h5 class="heading"  style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">Features:</h5>';
      }
      feature_list.querySelectorAll('li').forEach( list_item => {
        if (list_item.classList.contains('tab-icon') && !list_item.querySelector('.recycled') ) {
          html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + strip(list_item.querySelector('.shade-cert').textContent.replace('.shade-cert0{fill:none;stroke:var(--heading-color);stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}', '')) + '</span>';
        } else {
          if (list_item.querySelector('.text-content')) {
            html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + strip(list_item.querySelector('.text-content').innerText) + '</span>';
          } else {
            html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + strip(list_item.innerText) + '</span>';
          }
        }
      });
    });
  }

  

  if (spec_list_items) {
    html_code += '</br>';
    spec_list_items.forEach( spec_list => {
      // console.log('spec_list', spec_list);
      html_code += '<h5 class="heading" style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;text-transform:capitalize;">' + spec_list.closest('.spec-wrapper').querySelector('.heading').textContent + ':</h5>';
      spec_list.querySelectorAll('li').forEach( list_item => {
        html_code += '<span class="list-item" style="font-size:10px;display:block;line-height:13px;">' + list_item.innerText + '</span>';
      });
      
    });
  }


  if (spec_table_rows) {
    html_code += '</br>';
    html_code += '<h5 class="heading" style="color:#317853;font-size:12px;font-weight:bold;line-height:16px;margin-top:6px;">Product Specifications: </h5>';
    spec_table_rows.forEach(row => {
      let rowLabel = row.querySelectorAll('.spec-label')[0].innerText;
      let rowContent = row.querySelectorAll('.spec-value')[0] ? row.querySelectorAll('.spec-value')[0].innerText : '';
      
      // let rowContent = row.querySelectorAll('.spec-value')[0] ? row.querySelectorAll('.spec-value')[0].filter(item => !item.querySelector("style").textContent ) : '';
      if (rowLabel && rowContent) {
        html_code += '<div style="line-height:13px;"><span class="label" style="line-height:13px;font-size:10px;color:#677279;">' + rowLabel + ': &nbsp;&nbsp;</span>' 
                  + '<span class="row-content" style="padding-left:5px;font-size:10px;font-weight:bold;"> ' + rowContent + '&nbsp;</span></div>';
      } else {
         html_code += '<div style="line-height:13px;"><span class="label" style="line-height:13px;font-size:10px;">' + rowLabel.replaceAll('.circle-bg{fill:#2f734f;}').replaceAll('.circle-check{fill:#FFF;}').replaceAll('undefined', '').replaceAll('.circle-bg{fill:var(--heading-color);}', '') + '</span></div>';
      }
    });
  }


  
  
  // END Container Div

  if (product_description) {
    html_code += '</br>';
    html_code += ''
    +    '<div style="">'
    +    '<h5 class="heading" style="margin-top:6px;font-size:12px;font-weight:bold;line-height:16px;">Description: </h5>'
    +    '<div><span style="text-align:left;padding-right:20px;line-height:13px;font-size:10px;">' + strip(product_description.innerText.replace('\n', '').trim()) + '</span></div>'
    +    '</div>';
  }
    
  // html_code += '</br></br></br></br></br></br></br></br></br></br></br></br>'
  //           + '<span style="text-align:center;color:white;width:100%;font-size:12px;">'+footer+'</span>';

  // Close main container div
  html_code += '</div>';

  // console.log('html_code', html_code);
  
  
  doc.setProperties({
    title: product_title.innerText /* Insert the  Product Title here*/
  });

  /*
  var generateData = function(row) {
    console.log('row', row);
    var result = [];
    var data = {
      label: 'Label',
      value: 'Value'
    };
    // var data;
    for (var i = 0; i < row.length; i++) {
      // data.id = (i + 1).toString();
      if (row[i].querySelector('.spec-label')) {
        data.label = row[i].querySelector('.spec-label').textContent;
      }
      if (row[i].querySelector('.spec-value')) {
        data.value = row[i].querySelector('.spec-value').textContent;
      }
      if (row[i].querySelector('.spec-item')) {
        data.label = '';
        data.value = row[i].querySelector('.spec-item').textContent;
      }
      // data.value = row[i].querySelector('.spec_value').textContent;
      result.push(Object.assign({}, data));
    }
    return result;
  };
  
  function createHeaders(keys) {
    var result = [];
    for (var i = 0; i < keys.length; i += 1) {
      result.push({
        id: keys[i],
        name: keys[i],
        prompt: keys[i],
        width: 65,
        align: "center",
        padding: 0
      });
    }
    return result;
  }
  
  var headers = createHeaders([
    "label",
    "value"
  ]);
  
  // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
  */


  

  var img = new Image();
  img.src = product_template;
  img.setAttribute('crossOrigin', 'anonymous');
  img.onload = function () {
      /*image completely converted to base64string */
      var canvas = document.createElement('CANVAS');
      var ctx = canvas.getContext('2d');
      // var dataURL;
      canvas.height = this.height;
      canvas.width = this.width;
      ctx.drawImage(this, 0, 0);
      // dataURL = canvas.toDataURL(outputFormat);

      // /* call back function */
      // callback(dataURL);
      doc.addImage(img, "PNG", 0, 0, 211, 300);

      
      // // Color Green
      // doc.setTextColor(49, 120, 83);
      // doc.text(product_title_text, 15, 35);

      // Color Grey
      // doc.setTextColor(103, 114, 121);
    
      // doc.setFontSize(12);
      // doc.setFont("helvetica", "normal");
      // doc.setTextColor(103, 114, 121);

      // doc.text('Regular Price: ', 15, 45);
      // doc.text(regular_price_val, 30, 45);
    
      // // Color Red
      // doc.setTextColor(210, 0, 0);
      // doc.text('Sale Price: ', 15, 50);
      // doc.text(sale_price_val, 30, 50);

      // doc.setFillColor(49, 120, 83);
      // doc.rect(0, doc.internal.pageSize.height, doc.internal.pageSize.width, 40, "F");
      // doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 40
      // doc.table(15, 15, generateData(spec_table_rows), headers, { autoSize: false });
      

    
      doc.fromHTML(html_code,
        15,
        15, 
        {'width': 176},
        function() {
          // window.open(URL.createObjectURL(doc.output("blob")));
          doc.save(product_title.textContent + '.pdf');
      });
    
  };

}; 



const getPopupCookie = name => {
  const nameExpression = `${name}=`;
  const cookies = document.cookie.split(';');
  const cookie = cookies.find(currentCookie => currentCookie.includes(nameExpression));  
  return cookie ? cookie.trim().substring(nameExpression.length, cookie.length) : null;
}
const setPopupCookie = (name, value, expire = 90, path = '/') => {
  const date = new Date();
  date.setTime(date.getTime() + (expire * 24 * 3600 * 1000));
  const expires = date.toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=${path}`;
};


function toggleExpandableList(button) {
  const list = button.previousElementSibling;
  const button_text = button.querySelector('.expand-content');
  const isExpanded = list.classList.contains('expanded');

  // const icon = button.querySelector('.icon').innerHTML;

  console.log('isExpanded', isExpanded, list);
  
  if (isExpanded) {
    list.classList.remove('expanded');
    button_text.innerHTML = 'Show More';
    // if (icon) {
    //   icon.classList.add('icon-plus');
    //   icon.classList.remove('icon-minus');
    // }
  } else {
    list.classList.add('expanded');
    button_text.innerHTML = 'Show Less';
    // if (icon) {
    //   icon.classList.add('icon-minus');
    //   icon.classList.remove('icon-plus');
    // }
  }
}